import { baseApiV1 } from '@verantos-dev/app-state-base';
import {
  StudyArmDefinitionPayloadLegacy,
  StudyArmResponseLegacy,
  StudyArmsListResponsePayloadLegacy,
} from '@verantos-dev/types-cohorts';

// inject endpoints for feature into the baseApi
const studyArmsApiSliceLegacy = baseApiV1
  .enhanceEndpoints({
    addTagTypes: ['cohorts'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      /** Cohort List  */
      getStudyArms: builder.query<
        StudyArmsListResponsePayloadLegacy,
        { projectid: string; urlParams: string | null }
      >({
        // define the endpoint for the query
        query: ({ projectid, urlParams }) => {
          const params = urlParams ? `?${encodeURI(urlParams)}` : '';
          return `/studies/${projectid}/studyarms${params}`;
        },
        providesTags: ['cohorts'],
      }),

      /** Cohort Builder - cohort definition actions */
      getStudyArm: builder.query<
        StudyArmResponseLegacy,
        {
          projectId: string;
          studyArmId: string;
        }
      >({
        query: ({ projectId, studyArmId }) => `/studies/${projectId}/studyarm/${studyArmId}`,
        providesTags: ['cohorts'],
      }),

      saveStudyArm: builder.mutation<
        StudyArmResponseLegacy,
        {
          projectId: string;
          studyArmId: string;
          data: {
            cohortDefinition: StudyArmDefinitionPayloadLegacy;
          };
        }
      >({
        query: ({ projectId, studyArmId, data }) => ({
          url: `/studies/${projectId}/studyarm/${studyArmId}`,
          method: 'PUT',
          body: data,
        }),
        invalidatesTags: (result, error, { projectId, studyArmId }) => {
          // don't invalidate if error
          if (error) return [];
          return [{ type: 'cohorts', id: `StudyArm:${projectId}:${studyArmId}` }];
        },
      }),

      processStudyArm: builder.mutation<
        StudyArmResponseLegacy,
        {
          projectId: string;
          studyArmId: string;
          data: {
            cohortDefinition: StudyArmDefinitionPayloadLegacy;
          };
        }
      >({
        query: ({ projectId, studyArmId, data }) => ({
          url: `/studies/${projectId}/studyarm/${studyArmId}?process=true`,
          method: 'PUT',
          body: data,
        }),
        invalidatesTags: ['cohorts'],
      }),
    }),
  });

// export hooks to access/fetch data
export const {
  useGetStudyArmsQuery,
  useGetStudyArmQuery,
  useLazyGetStudyArmQuery,
  useLazyGetStudyArmsQuery,
  useProcessStudyArmMutation,
  useSaveStudyArmMutation,
} = studyArmsApiSliceLegacy;
